import {
  Add,
  BrandingWatermark,
  Category,
  Close,
  DeleteOutline,
  Edit,
  LocationOn,
  Person,
} from "@mui/icons-material";
import {
  Autocomplete,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  TextField,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ShelLogo from "../../assets/svg/Shell logo 1.svg";
import MobilLogo from "../../assets/svg/Reward item.svg";
import "./Manufacturers.css";
import React, { useEffect, useState } from "react";
import { Link, EditIcon } from "lucide-react";
import pinIcon from "../../assets/svg/pin 1.svg";
import { Controller, useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { newHost } from "../Categories/CategoryProfile";
import axios from "axios";
import { useParams } from "react-router-dom";
import Emptyfile1 from "../../assets/svg/Emptyfile1.svg";
import defaultImage from "../../assets/svg/defultImage.svg";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import { useSelector } from "react-redux";

export const newImageUrl = "https://estbn.com/EstbnNew/public";

const ManufactureProfile = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id } = useParams();
  const [ManufactureValue, setManufactureValue] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [brandModalShow, setBrandModalShow] = useState(false);
  const [manufactureById, setManufacureById] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [countries, setCountries] = useState([]);
  const [brands, setBrands] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [removeLocationShow, setRemoveLocationShow] = useState(false);

  const handleAddBrandShow = () => {
    setBrandModalShow(true);
  };
  const handleAddBrandClose = () => {
    setBrandModalShow(false);
  };
  const handleAddLocationShow = () => {
    setIsEdit(false);

    setShowModal(true);
  };
  const handleAddLocationClose = () => {
    setShowModal(false);
    reset({
      location: "",
      country_id: "",
    });
  };
  const handleEditLocation = (location) => {
    setLocationId(location.id);
    setIsEdit(true);
    setShowModal(true);
    setValue("location", location?.location);
    setValue("country_id", location?.country.id);
  };
  const handleRemoveLoactionShow = (id) => {
    setRemoveLocationShow(true);
    setLocationId(id);
  };
  const handleRemoveLocationClose = () => {
    setRemoveLocationShow(false);
  };
  const getManufactureById = async () => {
    try {
      const response = await axios.get(`${newHost}portal/manufacturers/${id}`, {
        headers: newHeaders,
      });

      setManufacureById(response.data.data?.manufacturer);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await axios.get(`${newHost}portal/countries`, {
        headers: newHeaders,
      });

      setCountries(response.data.data?.countries);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllBrands = async () => {
    try {
      const response = await axios.get(`${newHost}portal/brands`, {
        headers: newHeaders,
      });
      console.log(response);
      setBrands(response.data.data?.brands);
    } catch (error) {
      console.log(error);
    }
  };
  const submitLocation = async (data) => {
    if (isEdit) {
      try {
        const response = await axios.post(
          `${newHost}portal/manufacturer_locations/${locationId}`,
          {
            ...data,
            _method: "PATCH",
          },
          {
            headers: newHeaders,
          }
        );
        reset({
          location: "",
          country_id: "",
        });
        toast.success(response.data.data?.message);
        getManufactureById();
        setShowModal(false);
      } catch (error) {
        toast.error(error.response.data?.message);
      }
    } else {
      try {
        const response = await axios.post(
          `${newHost}portal/manufacturer_locations`,
          {
            ...data,
            manufacturer_id: id,
          },
          {
            headers: newHeaders,
          }
        );
        console.log(response);
        reset({
          location: "",
          country_id: "",
        });
        toast.success(response.data.data?.message);
        getManufactureById();
        setShowModal(false);
      } catch (error) {
        console.log(error);
        toast.error(error.response.data?.message);
      }
    }
  };
  const removeLocationFromManufacture = async () => {
    try {
      const response = await axios.delete(
        `${newHost}portal/manufacturer_locations/${locationId}`,
        {
          headers: newHeaders,
        }
      );
      toast.success(response.data.data?.message);
      getManufactureById();
      setRemoveLocationShow(false);
    } catch (error) {
      toast.error(error.response.data?.message);
    }
  };
  const BrandsOption = [
    {
      value: "shell",
      label: "Shell",
      icon_url: ShelLogo,
    },
    {
      value: "mobil",
      label: "Mobil",
      icon_url: MobilLogo,
    },
    {
      value: "shell",
      label: "Shell",
      icon_url: ShelLogo,
    },
    {
      value: "mobil",
      label: "Mobil",
      icon_url: MobilLogo,
    },
  ];
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    getManufactureById();
    getAllCountries();
    getAllBrands();
  }, []);

  return (
    <>
      <DeleteModal
        showDelete={removeLocationShow}
        handleDeleteClose={handleRemoveLocationClose}
        textMessage={" Are you sure you want to remove this Location?"}
        deleteFunction={removeLocationFromManufacture}
      />
      <Modal show={brandModalShow} onHide={handleAddBrandClose}>
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
          <Modal.Title>Add Brand</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mt-3">
              <Controller
                name="brand_id"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    multiple
                    size="small"
                    className="w-100"
                    id="category"
                    disableCloseOnSelect
                    value={brands.filter((s) =>
                      (field.value || []).includes(s.id)
                    )}
                    onChange={(e, newValue) => {
                      field.onChange(newValue.map((v) => v.id));
                    }}
                    options={brands}
                    getOptionLabel={(option) => option.name}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const tagProps = getTagProps({ index });

                        return (
                          <span
                            {...tagProps}
                            key={option.id}
                            className="d-flex align-items-center mx-1"
                            style={{
                              padding: "2px 6px",
                              borderRadius: "12px",
                              backgroundColor: "#e0e0e0",
                              fontSize: "0.8rem",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <img
                              src={
                                option.logo_path
                                  ? newImageUrl + option.logo_path
                                  : defaultImage
                              }
                              alt=""
                              style={{
                                width: 18,
                                height: 18,
                                borderRadius: "50%",
                              }}
                            />

                            <span>{option.name}</span>

                            <span
                              onClick={tagProps.onDelete}
                              style={{
                                cursor: "pointer",
                                fontSize: "12px",
                                lineHeight: 1,

                                color: "#555",
                              }}
                            >
                              <Close sx={{ color: "red", fontSize: "16px" }} />
                            </span>
                          </span>
                        );
                      })
                    }
                    // renderTags={(value, getTagProps) =>
                    //   value.map((option, index) => (
                    //     <span
                    //       {...getTagProps({ index })}
                    //       key={option.id}
                    //       className="d-flex align-items-center mx-1"
                    //       style={{
                    //         padding: "2px 6px",
                    //         borderRadius: "12px",
                    //         backgroundColor: "#e0e0e0",
                    //         fontSize: "0.8rem",

                    //         display: "flex",
                    //         alignItems: "center",
                    //         gap: "4px",

                    //       }}
                    //     >
                    //       <img
                    //         src={
                    //           option.logo_path
                    //             ? newImageUrl + option.logo_path
                    //             : defaultImage
                    //         }
                    //         alt=""
                    //         style={{
                    //           width: 18,
                    //           height: 18,
                    //           borderRadius: "50%",
                    //         }}
                    //       />
                    //       {option.name}
                    //     </span>
                    //   ))
                    // }

                    renderOption={(props, option, state) => (
                      <li
                        {...props}
                        className="custom-menu-item"
                        style={{
                          padding: "10px 12px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          margin: "5px",

                          backgroundColor: state.selected
                            ? "rgba(193, 203, 213, 0.15)"
                            : state.hovered
                            ? "rgba(175, 175, 175, 0.06)"
                            : "transparent",

                          borderRadius: "6px",
                        }}
                      >
                        <img
                          src={
                            option?.logo_path
                              ? newImageUrl + option?.logo_path
                              : defaultImage
                          }
                          alt=""
                          style={{
                            width: 22,
                            height: 22,
                            borderRadius: "50%",
                          }}
                        />

                        <div className="label-size m-0">{option.name}</div>
                      </li>
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: 220,
                        overflowY: "auto",
                        padding: "6px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField placeholder="Select Brands" {...params} />
                    )}
                  />
                )}
              />
            </div>
            <div className="d-flex gap-4 justify-content-center align-items-center  py-4">
              <button
                className="px-5 py-2 btn btn-light"
                onClick={handleAddLocationClose}
              >
                Cancel
              </button>
              <button className="px-5 py-2 btn btn-dark">Save</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal show={showModal} onHide={handleAddLocationClose}>
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }} closeButton>
          <Modal.Title>
            {isEdit ? "Update Location" : "Add Location"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(submitLocation)}>
            <div className="my-2">
              <TextField
                size="small"
                {...register("location")}
                className="w-100"
                type="text"
                placeholder="Add Location"
              />
            </div>

            <div className="my-2">
              <Controller
                name="country_id"
                control={control}
                render={({ field }) => {
                  const options = countries.map((option) => ({
                    label: option.name,
                    id: option.id,
                  }));

                  return (
                    <>
                      <Autocomplete
                        size="small"
                        options={options}
                        onChange={(e, item) => {
                          field.onChange(item ? item.id : null);
                        }}
                        value={
                          options.find((opt) => opt.id == field.value) || null
                        }
                        renderOption={(props, option) => (
                          <li {...props} className="p-3 label-size">
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Country" />
                        )}
                      />
                    </>
                  );
                }}
              />
            </div>
            <div className="d-flex gap-4 justify-content-center align-items-center  py-4">
              <button
                type="reset"
                className="px-5 py-2 btn btn-light"
                onClick={handleAddLocationClose}
              >
                Cancel
              </button>
              <button className="px-5 py-2 btn btn-dark">Save</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="m-4 min-vh-100">
        <div className="row align-items-center">
          <div className="col-md-4 col-sm-12">
            <h5 className="fw-semibold m-0">Manufacturer Profile</h5>
          </div>
          <div className="col-md-8 col-sm-12">
            <div className="d-flex align-items-center">
              <Box className="my-3">
                <BottomNavigation
                  showLabels
                  value={ManufactureValue}
                  onChange={(event, newValue) => {
                    setManufactureValue(newValue);
                  }}
                  className="rounded-3 border d-flex align-items-center manufacture-navigation-buttons "
                >
                  <BottomNavigationAction
                    className="BottomNavigationAction"
                    label={`Locations`}
                  />
                  <BottomNavigationAction
                    className="BottomNavigationAction"
                    label={`Brands`}
                  />
                </BottomNavigation>
              </Box>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="min-vh-100 border rounded-4 p-3">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="m-0 fw-bold">{manufactureById?.name}</h5>
                <div className="border rounded-5 p-2">
                  <Edit color="action" />
                </div>
              </div>
              <h5 className="mt-3 fw-semibold">Manufacturer Info</h5>
              <div className="d-flex gap-2 align-items-center mb-2 mt-3">
                <Person fontSize="small" />
                <p className="categoryInfo m-0">Created by Ahmed Anany</p>
              </div>
              <div className="d-flex gap-2 align-items-center my-2">
                <CalendarTodayIcon fontSize="small" />
                <p className="categoryInfo m-0">{`Created on ${new Date(
                  manufactureById?.created_at
                ).toLocaleDateString()}`}</p>
              </div>
              <div className="d-flex gap-2 align-items-center my-2">
                <Category fontSize="small" />
                <div className="d-flex gap-1 align-items-center">
                  {manufactureById?.categories.map((category) => (
                    <img
                      className="service-icon m-0"
                      src={`${newImageUrl}${category.image_url}`}
                      alt="category-img"
                    />
                  ))}
                </div>
              </div>
              <div className="d-flex gap-2 align-items-center my-2">
                <Link width={"20px"} />
                <p className="categoryInfo m-0">
                  {manufactureById?.website_url}
                </p>
              </div>
              <div className="d-flex gap-2 align-items-center my-2">
                <BrandingWatermark fontSize="small" />
                <p className="categoryInfo m-0">{`${manufactureById?.brands?.length} Brands`}</p>
              </div>
              <div className="d-flex gap-2 align-items-center my-2">
                <LocationOn fontSize="small" />
                <p className="categoryInfo m-0">{`${manufactureById?.locations?.length} Locations`}</p>
              </div>
            </div>
          </div>
          <div className="col-md-9 col-sm-12">
            <div className="border rounded-4 min-vh-100">
              {ManufactureValue == 0 ? (
                <>
                  <div className="d-flex align-items-center justify-content-between p-4">
                    <h5>Locations</h5>
                    <button
                      onClick={handleAddLocationShow}
                      className="btn btn-light"
                    >
                      <Add />
                      Add Location
                    </button>
                  </div>
                  {manufactureById?.locations.length > 0 ? (
                    manufactureById?.locations.map((location) => (
                      <div className=" shadow-sm bg-white rounded-2 my-3 mx-3 p-3 d-flex justify-content-between align-items-center ">
                        <div className=" d-flex gap-3 align-items-center">
                          <img src={pinIcon} alt="pin" />
                          <h6 className="fw-semibold m-0">{`${location?.location}, ${location.country?.name}`}</h6>
                        </div>
                        <div className=" d-flex gap-2 align-items-center">
                          <EditIcon
                            onClick={() => handleEditLocation(location)}
                            color="#535353"
                          />
                          <DeleteOutline
                            onClick={() =>
                              handleRemoveLoactionShow(location.id)
                            }
                            color="error"
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className=" d-flex  flex-column  align-items-center justify-content-center">
                      <div className=" text-center">
                        <div>
                          <img
                            src={Emptyfile1}
                            className=""
                            alt="No Sub Category"
                          />
                        </div>
                        <div className="no-data-text">
                          <div>No Location added yet.</div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="d-flex align-items-center justify-content-between p-4">
                    <h5>Brands</h5>
                    <button
                      onClick={handleAddBrandShow}
                      className="btn btn-light"
                    >
                      <Add />
                      Add Brand
                    </button>
                  </div>
                  {manufactureById?.brands?.length > 0 ? (
                    manufactureById?.brands?.map((brand) => (
                      <div className=" shadow-sm bg-white rounded-2 my-3 mx-3 p-3 d-flex justify-content-between align-items-center ">
                        <div className=" d-flex gap-3 align-items-center">
                          <img
                            style={{ width: "30px" }}
                            className=""
                            src={`${newImageUrl}${brand?.logo_path}`}
                            alt="logo"
                          />
                          <h6 className="fw-semibold m-0">{brand?.name}</h6>
                        </div>
                        <div className=" d-flex gap-2 align-items-center">
                          <DeleteOutline color="error" />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className=" d-flex  flex-column  align-items-center justify-content-center">
                      <div className=" text-center">
                        <div>
                          <img
                            src={Emptyfile1}
                            className=""
                            alt="No Sub Category"
                          />
                        </div>
                        <div className="no-data-text">
                          <div>No Brand added yet.</div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManufactureProfile;
